import {ErrorMessages} from 'constants/Errors';
import {SuccessMessages} from 'constants/Success';

import {AxiosResponse} from 'axios';
import {call, put} from 'redux-saga/effects';
import {updateUserData} from 'services/auth-service';
import {setSuccessAC} from 'store/app/appSlice';
import {handleError} from 'store/app/error/saga';
import {setPreviewSrcAC} from 'store/imageUploader/imageUploaderSlice';
import ApiData from 'typescript/interfaces/ApiData';
import User from 'typescript/models/User';

import {updateEditorACS} from '../requestAC';
import {setSingleEditorAC} from '../singlePageEditorSlice';

export function* updateEditor(action: ReturnType<typeof updateEditorACS>) {
  const {id, data} = action.payload;

  try {
    const response: AxiosResponse<ApiData<User>> = yield call(updateUserData, id, data);

    yield put(setSingleEditorAC(response.data.data));
    yield put(setSuccessAC(SuccessMessages.UPDATE_EDITOR));
  } catch (error) {
    yield call(handleError, error, ErrorMessages.PAGE_EDITOR_UPDATE);
  } finally {
    yield put(setPreviewSrcAC(undefined));
  }
}
